import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { GPErrorHandler } from 'src/app/services/gp-error';
import { ToastrService } from 'ngx-toastr';
import { ContractorService } from '../../../../services/contractor.service';
import {
  ContractorType,
  ContractorTypeSearchOptions,
  CONTRACTOR_STATUS_CONFIG,
  ContractorRegistrationRow,
  ContractorRegistrationAction
} from '../contractor-type/contractor-type.model';
import { finalize, filter } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { SecurityService } from 'src/app/services';
import { Actions } from 'src/app/models';
import { WorkflowValidationService } from 'src/app/services/workflow-validation.service';
import { CustomFieldDataOperationType } from 'src/app/models/custom-field-data-operations';
import { CopyContractorTypeRequest } from 'src/app/models/copy-contractor-request';
import { WorkflowContextService, ClientService } from 'src/app/services';
import { WorkflowService } from 'src/app/services/workflow.service';
import { WorkflowCheckpoint } from 'src/app/models/workflow-checkpoint';
import { ItemSearchOptionField } from 'src/app/components/filter-list/models/filterClasses';
import { RegistrationStatus } from 'src/app/models/registration';
import {
  FilterBuilderParam,
  FilterBuilderOutput
} from 'src/app/models/filter-builder';
import { ColumnOption } from 'src/app/models/grid-settings';

import { ContractorsJanusApplicationComponent } from 'src/app/views/admin/contractors-janus/contractors-janus-table/contractors-janus-application/contractors-janus-application.component';
import { ContractorsJanusRenewComponent } from 'src/app/views/admin/contractors-janus/contractors-janus-table/contractors-janus-renew/contractors-janus-renew.component';
import { ContractorsJanusActionComponent } from 'src/app/views/admin/contractors-janus/contractors-janus-table/cells-janus/contractors-janus-action-cell/contractors-janus-action.component';
import { StaffContractorRegistrationDetailsComponent } from 'src/app/views/admin/contractors-janus/contractor-registration-details/contractor-registration-details.component';
import { ContractorsJanusProfileViewComponent } from 'src/app/views/admin/contractors-janus/all-contractors/contractors-janus-profile-view/contractors-janus-profile-view.component';
import { MatDialog } from '@angular/material/dialog';
import { ImportContractorTypeModalComponent } from 'src/app/views/admin/contractor-editor/import-contractor-type-modal/import-contractor-type-modal.component';

@Component({
  selector: 'app-contractor-types',
  standalone: false,
  templateUrl: './contractor-types.component.html',
  styleUrls: ['./contractor-types.component.scss']
})
export class ContractorTypesComponent implements OnInit, OnDestroy {
  clients: any[] = [];
  clientOptions: any[] = [];
  contractorTypes: ContractorType[] = [];

  isLoading = false;
  hasError = false;
  errorMessage = '';
  expandedId: string | null = null;
  isChildRouteActive = false;
  canManageContractors = false;
  isGlobalAdmin = false;
  isExportRouteActive = false;
  overlayOffsetTop = 0;

  private routerSub: Subscription;
  private openMenuForId: string | null = null;
  private adminClientsLoaded = false;
  private publishFormMap: { [id: string]: UntypedFormGroup } = {};
  copyFormMap: { [id: string]: UntypedFormGroup } = {};

  isValidatingMap: { [id: string]: boolean } = {};
  customFieldMigrationQueueItemsMap: { [id: string]: any[] } = {};
  hasContractorToRegistrationMoveMap: { [id: string]: boolean } = {};
  hasRegistrationToContractorMoveMap: { [id: string]: boolean } = {};

  detailsMap: { [typeId: string]: ContractorType } = {};
  isDetailsLoadingMap: { [typeId: string]: boolean } = {};
  detailsErrorMap: { [typeId: string]: string } = {};

  checkpoints: WorkflowCheckpoint[] = null;
  selectedWorkflowId: string = null;

  currentRegistrations: ContractorRegistrationRow[] = [];
  isTableLoading = false;
  tableErrorMessage = '';

  currentPage = 0;
  pageSize = 10;
  totalPages = 0;
  totalRecords = 0;

  sortField: string | null = null;
  sortDesc: boolean | null = null;

  expandedComponent: any = null;
  expandedComponentInputs: any = null;
  private _columnsCache: { [typeId: string]: any[] } = {};

  // --- OVERLAY MODAL STATES ---
  isHistoryModalOpen = false;
  historyModalTitle = '';

  isTypeActionModalOpen = false;
  typeActionModalTitle = '';

  isRegistrationActionModalOpen = false;
  registrationModalTitle = '';
  registrationModalDesc = '';
  registrationModalIsSuccess = false;
  // ----------------------------

  selectedType: ContractorType | null = null;
  currentTypeAction: 'publish' | 'delete' | 'copy' | null = null;

  selectedRow: ContractorRegistrationRow | null = null;
  currentAction: ContractorRegistrationAction = null;
  selectedTypeId: string | null = null;

  contractorFilterParams: FilterBuilderParam[] = [];
  contractorExportColumns: ColumnOption[] = [];
  activeFiltersMap: { [typeId: string]: FilterBuilderOutput | any } = {};
  isEditorVisibleMap: { [typeId: string]: boolean } = {};

  isPublishHistoryModalOpen = false;
  selectedPublishWorkflowId: string;
  publishHistoryModalTitle = '';

  filterTypes = [
    {
      name: 'contains'
    },
    {
      name: 'is'
    },
    {
      name: 'in'
    },
    {
      name: 'range'
    }
  ];

  constructor(
    private _contractorSvc: ContractorService,
    private router: Router,
    private route: ActivatedRoute,
    private _securitySvc: SecurityService,
    private _validationSvc: WorkflowValidationService,
    private _context: WorkflowContextService,
    private _clientSvc: ClientService,
    private _workflowSvc: WorkflowService,
    private gpError: GPErrorHandler,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private _dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this._securitySvc
      .isLoginEntitled(Actions.CONTRACTORS_MANAGE)
      .subscribe(result => {
        this.canManageContractors = result;
      });

    this._securitySvc.isLoginEntitled(Actions.DO_ANYTHING).subscribe(result => {
      this.isGlobalAdmin = result;
    });

    this.loadContractorTypes();
    this.checkChildRoute();
    this.initializeExportAndFilterConfiguration();

    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const wasChildActive = this.isChildRouteActive;
        this.checkChildRoute();

        if (wasChildActive && !this.isChildRouteActive) {
          if (this.route.snapshot.queryParamMap.has('refresh')) {
            this.loadContractorTypes();
          }
        }
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  // Start Code added by Sanchit on 07/09/2026 Added filter types
  initializeExportAndFilterConfiguration(): void {
    this.contractorFilterParams = [
      {
        id: 'contractorName',
        name: 'Name',
        inputType: 'text',
        types: ['is', 'contains']
      },
      {
        id: 'contractor',
        name: 'Business Name',
        inputType: 'text',
        types: ['is', 'contains']
      },
      {
        id: 'registeredOn',
        name: 'Registered On',
        inputType: 'date',
        types: ['is', 'range']
      },
      {
        id: 'effectiveOn',
        name: 'Effective On',
        inputType: 'date',
        types: ['is', 'range']
      },
      {
        id: 'expiresOn',
        name: 'Expires On',
        inputType: 'date',
        types: ['is', 'range']
      },
      {
        id: 'status',
        name: 'Status',
        inputType: 'text',
        types: ['is', 'in'],
        options: [
          // Start Code added by Sanchit on 07/09/2026
          // { name: 'Active', value: 'Active' },
          // { name: 'Disabled', value: 'Disabled' },
          // { name: 'Expired', value: 'Expired' }
          { name: 'Pending', value: 'Pending' },
          { name: 'Approved', value: 'Approved' },
          { name: 'Denied', value: 'Denied' },
          { name: 'Expired', value: 'Expired' },
          { name: 'Inactive', value: 'Inactive' },
          { name: 'Deleted', value: 'Deleted' },
          { name: 'Renewed', value: 'Renewed' },
          { name: 'Disabled', value: 'Disabled' }
          // End Code added by Sanchit on 07/09/2026
          // End Code added by Sanchit on 07/16/2026
        ]
      }
    ];

    this.contractorExportColumns = [
      {
        name: 'contractorName',
        label: 'Name',
        checked: true,
        includeInExport: true
      },
      {
        name: 'contractor',
        label: 'Business Name',
        checked: true,
        includeInExport: true
      },
      {
        name: 'registeredOn',
        label: 'Registered On',
        checked: true,
        includeInExport: true
      },
      {
        name: 'effectiveOn',
        label: 'Effective On',
        checked: true,
        includeInExport: true
      },
      {
        name: 'expiresOn',
        label: 'Expires On',
        checked: true,
        includeInExport: true
      },
      { name: 'status', label: 'Status', checked: true, includeInExport: true }
    ];
  }

  handleGridFiltersChange(typeId: string, filters: FilterBuilderOutput): void {
    this.activeFiltersMap[typeId] = filters;
    this.currentPage = 0;
    this.searchRegistrations(typeId);
  }

  handleGridColumnsChange(typeId: string, event: any): void {
    // Start Code added by Sanchit on 07/01/2026
    const tableColumns = this._columnsCache[typeId];
    if (!tableColumns) {
      return;
    }
    // New Filter -> show all columns
    if (!event.columns || event.columns.length === 0) {
      tableColumns.forEach(col => (col.hidden = false));
    } else {
      const columnMap = {
        contractorName: 'name',
        contractor: 'businessName',
        registeredOn: 'registrationDate',
        effectiveOn: 'effectiveDate',
        expiresOn: 'expirationDate',
        status: 'status'
      };
      tableColumns.forEach(col => {
        if (col.key === 'action') {
          col.hidden = false;
          return;
        }
        col.hidden = !event.columns.some(c => columnMap[c.name] === col.key);
      });
    }
    this._columnsCache[typeId] = [...tableColumns];
    // End Code added by Sanchit on 07/01/2026
  }

  private buildRegistrationFilters(typeId: string): ItemSearchOptionField[] {
    const filterObjects: ItemSearchOptionField[] = [
      {
        title: 'contractorTypeId',
        options: [
          {
            title: '',
            filterText: typeId,
            selected: true,
            searchText: '',
            strOperator: ''
          }
        ]
      }
    ];

    const customFilters = this.activeFiltersMap[typeId];

    if (!customFilters) {
      return filterObjects;
    }

    const statusMap: { [key: string]: string } = {
      Pending: '0',
      Approved: '1',
      Denied: '2',
      Expired: '3',
      Inactive: '4',
      Deleted: '5',
      Renewed: '6',
      Disabled: '7'
    };

    Object.keys(customFilters).forEach(key => {
      const filter = customFilters[key];

      if (
        !filter ||
        filter.value === null ||
        filter.value === undefined ||
        filter.value === ''
      ) {
        return;
      }

      const isDateFilter = [
        'registeredOn',
        'effectiveOn',
        'expiresOn'
      ].includes(filter.id);

      const isStatusFilter = filter.id === 'status';

      filterObjects.push({
        title: filter.id,
        options: [
          {
            title: '',
            selected: true,
            inputType: isDateFilter ? 'date' : undefined,
            filterText: !isDateFilter && !isStatusFilter ? filter.value : '',
            searchText: isDateFilter
              ? filter.value
              : isStatusFilter
              ? statusMap[filter.value] ?? filter.value
              : '',
            // Preserve the selected date operator ("is" / "range").
            strOperator: isStatusFilter ? '' : filter.type
          }
        ]
      });
    });

    return filterObjects;
  }

  private buildFiltersForExport(typeId: string): ItemSearchOptionField[] {
    return this.buildRegistrationFilters(typeId);
  }

  private triggerExport(type: ContractorType, format: 'excel' | 'csv'): void {
    if (!this._context.client) return;

    this.toastr.info(
      `Generating ${format.toUpperCase()} export for ${type.name}...`
    );
    this.isTableLoading = true;

    const filterObjects = this.buildFiltersForExport(type.id);
    const exportColumns = this.contractorExportColumns
      .filter(c => c.includeInExport)
      .map(c => c.name);

    const useExcel = format === 'excel';
    const exportSortField = this.sortField || 'registeredOn';
    const exportSortDesc = this.sortDesc !== null ? this.sortDesc : true;

    this._contractorSvc
      .exportContractorRegistrations(
        this._context.client.id,
        useExcel,
        exportColumns,
        exportSortField,
        exportSortDesc,
        filterObjects,
        0,
        10
      )
      .pipe(finalize(() => (this.isTableLoading = false)))
      .subscribe({
        next: (response: any) => {
          const extension = format === 'excel' ? 'xlsx' : 'csv';
          const mimeType =
            format === 'excel'
              ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              : 'text/csv';

          const blob = new Blob([response], { type: mimeType });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;

          const dateStr = new Date().toISOString().split('T')[0];
          const safeName = type.name.replace(/[^a-zA-Z0-9]/g, '_');
          a.download = `${safeName}_Contractors_${dateStr}.${extension}`;

          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
          a.remove();

          this.toastr.success(
            `${format.toUpperCase()} Export downloaded successfully!`
          );
        },
        error: err => {
          this.gpError.handleError(err);
          this.toastr.error(
            `Failed to generate ${format.toUpperCase()} export.`
          );
        }
      });
  }

  handleExcelExport(type: ContractorType): void {
    this.triggerExport(type, 'excel');
  }

  handleCsvExport(type: ContractorType): void {
    this.triggerExport(type, 'csv');
  }

  handleEditorVisibility(typeId: string, isVisible: boolean): void {
    this.isEditorVisibleMap[typeId] = isVisible;
  }

  getContractorColumns(type: ContractorType, tableRef: any): any[] {
    if (!this._columnsCache[type.id]) {
      this._columnsCache[type.id] = [
        // { key: 'select', headerType: 'checkbox', cellType: 'checkbox' },
        { key: 'name', label: 'Name', headerType: 'text', cellType: 'text' },
        {
          key: 'businessName',
          label: 'Business Name',
          headerType: 'text',
          cellType: 'text'
        },
        {
          key: 'registrationDate',
          label: 'Registered On',
          headerType: 'text',
          cellType: 'text'
        },
        {
          key: 'effectiveDate',
          label: 'Effective On',
          headerType: 'text',
          cellType: 'text'
        },
        {
          key: 'expirationDate',
          label: 'Expires On',
          headerType: 'text',
          cellType: 'text'
        },
        {
          key: 'status',
          label: 'Status',
          headerType: 'text',
          cellType: 'status'
        },
        {
          key: 'action',
          label: 'Actions',
          headerType: 'text',
          cellType: 'component',
          component: ContractorsJanusActionComponent,
          componentInputs: (row: ContractorRegistrationRow) => ({
            row,

            viewDetails: (r: ContractorRegistrationRow) =>
              this.openInline('details', r, type.id, tableRef),

            viewProfile: (r: ContractorRegistrationRow) =>
              this.openInline('profile', r, type.id, tableRef),

            viewApplication: (r: ContractorRegistrationRow) =>
              this.openInline('application', r, type.id, tableRef),

            renew: (r: ContractorRegistrationRow) =>
              this.openInline('renew', r, type.id, tableRef),

            disable: (r: ContractorRegistrationRow) =>
              this.openActionModal(r, 'disable', type.id),

            enable: (r: ContractorRegistrationRow) =>
              this.openActionModal(r, 'enable', type.id),

            delete: (r: ContractorRegistrationRow) =>
              this.openActionModal(r, 'delete', type.id),

            canEnable: (r: ContractorRegistrationRow) =>
              this.canManageContractors && this.canEnable(r),

            canDisable: (r: ContractorRegistrationRow) =>
              this.canManageContractors && this.canDisable(r),

            canDelete: (r: ContractorRegistrationRow) =>
              this.canManageContractors && this.canDelete(r),

            canRenew: (r: ContractorRegistrationRow) =>
              this.canManageContractors && this.canRenew(r)
          })
        }
      ];
    }
    return this._columnsCache[type.id];
  }

  loadContractorTypes(): void {
    this.isLoading = true;
    this.hasError = false;

    const options: ContractorTypeSearchOptions = { searchText: '' };

    this._contractorSvc
      .searchContractorTypes(options)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (data: ContractorType[]) => {
          this.contractorTypes = data || [];
        },
        error: err => {
          this.gpError.handleError(err);
          this.hasError = true;
          this.errorMessage = 'Unable to load contractor types.';
        }
      });
  }

  checkChildRoute(): void {
    this.isChildRouteActive = this.route.children.length > 0;
    this.isExportRouteActive = this.router.url.includes('scheduled-export');
  }

  closeExportEditor(): void {
    this.router.navigate(['./'], { relativeTo: this.route });
  }

  toggleExpand(id: string): void {
    this.expandedId = this.expandedId === id ? null : id;

    if (this.expandedId === id) {
      this.currentPage = 0;
      this.pageSize = 10;
      this.sortField = null;
      this.sortDesc = null;
      this.currentRegistrations = [];
      this.tableErrorMessage = '';

      this.loadDetailsAndRegistrations(id);
    }
  }

  private loadDetailsAndRegistrations(typeId: string): void {
    if (this.detailsMap[typeId]) {
      this.searchRegistrations(typeId);
      return;
    }

    this.isDetailsLoadingMap[typeId] = true;
    this.detailsErrorMap[typeId] = '';

    this._contractorSvc.getContractorType(typeId, true).subscribe({
      next: (ct: ContractorType) => {
        this.detailsMap[typeId] = ct;
        this.isDetailsLoadingMap[typeId] = false;
        this.searchRegistrations(typeId);
      },
      error: err => {
        this.gpError.handleError(err);
        this.isDetailsLoadingMap[typeId] = false;
        this.detailsErrorMap[typeId] =
          'Failed to load contractor type details.';
      }
    });
  }

  private searchRegistrations(typeId: string): void {
    if (!this._context.client) return;

    this.isTableLoading = true;
    this.tableErrorMessage = '';

    const filterObjects = this.buildRegistrationFilters(typeId);

    const pageNumber = this.currentPage + 1;

    this._contractorSvc
      .searchContractorRegistrations(
        this._context.client.id,
        this.sortField,
        this.sortDesc,
        filterObjects,
        pageNumber,
        this.pageSize,
        false
      )
      .subscribe({
        next: (res: any) => {
          this.totalPages = res?.pageCount || 0;
          this.totalRecords = res?.recordCount || 0;

          this.currentRegistrations = (res?.contractorRegistrations || []).map(
            (r: any): ContractorRegistrationRow => {
              const first = (r.contractor?.contactFirstName || '').trim();
              const last = (r.contractor?.contactLastName || '').trim();
              const fullName = `${first} ${last}`.trim();

              return {
                id: r.id,
                contractorId: r.contractorID,
                registerApplicationId: r.registerApplicationId,
                createdApplicationId: r.registerApplicationId,
                name: fullName || 'N/A',
                businessName: r.contractor?.businessName || 'N/A',
                registrationInfo: {
                  name: fullName || 'N/A',
                  business: r.contractor?.businessName || 'N/A'
                },
                type: r.contractor?.businessName || 'N/A',
                registrationDate: r.registeredOnString || 'N/A',
                effectiveDate: r.effectiveOnString || 'N/A',
                expirationDate: r.expiresOnString || 'N/A',
                approvedDate: r.approvedOnString || 'N/A',
                status: r.status != null ? RegistrationStatus[r.status] : 'N/A',
                actions: true
              };
            }
          );

          this.isTableLoading = false;
        },
        error: err => {
          this.gpError.handleError(err);
          this.isTableLoading = false;
          this.tableErrorMessage = 'Failed to load contractors.';
          this.currentRegistrations = [];
        }
      });
  }

  onRegistrationsSortChanged(
    typeId: string,
    evt: { sortField: string | null; sortDescending: boolean | null }
  ): void {
    this.sortField = evt.sortField;
    this.sortDesc = evt.sortDescending;
    this.currentPage = 0;
    this.searchRegistrations(typeId);
  }

  onRegistrationsRowsPerPageChange(typeId: string, size: number): void {
    this.pageSize = size;
    this.currentPage = 0;
    this.searchRegistrations(typeId);
  }

  onRegistrationsPageChange(typeId: string, pageIndex: number): void {
    this.currentPage = pageIndex;
    this.searchRegistrations(typeId);
  }

  onCreateNew(): void {
    if (this.isChildRouteActive) return;
    this.router.navigate(['add'], { relativeTo: this.route });
  }

  onEdit(type: ContractorType, event: MouseEvent): void {
    event.stopPropagation();
    this.closeMenu();

    const clickedElement = event.currentTarget as HTMLElement;

    const rowElement = clickedElement.closest(
      '.type-card'
    ) as HTMLElement | null;

    const greyContainer = document.querySelector(
      '.grey-container'
    ) as HTMLElement | null;

    let overlayRowTop = 24;

    if (rowElement && greyContainer) {
      const rowRect = rowElement.getBoundingClientRect();
      const containerRect = greyContainer.getBoundingClientRect();
      overlayRowTop = rowRect.top - containerRect.top;
    }

    this.router.navigate(['edit', type.id], {
      relativeTo: this.route,
      state: {
        overlayRowTop
      }
    });
  }

  isMenuOpen(id: string): boolean {
    return this.openMenuForId === id;
  }

  toggleMenu(id: string, ev?: Event): void {
    if (ev) {
      ev.stopPropagation();
      ev.preventDefault();
    }
    this.openMenuForId = this.openMenuForId === id ? null : id;
  }

  closeMenu(): void {
    this.openMenuForId = null;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeMenu();
  }

  isPublished(ct: ContractorType): boolean {
    return (ct as any).lastPublishedOn != null;
  }

  hasChangesAvailable(ct: ContractorType): boolean {
    const fullCt = this.detailsMap[ct.id] || ct;
    const rw = (fullCt as any).registerWorkflow;
    const renw = (fullCt as any).renewWorkflow;

    return !!(
      (rw && rw.areThereChangesNotPublished) ||
      (renw && renw.areThereChangesNotPublished)
    );
  }

  canPublish(ct: ContractorType): boolean {
    if (!this.canManageContractors) return false;
    return !this.isPublished(ct) || this.hasChangesAvailable(ct);
  }

  getPublishForm(type: ContractorType): UntypedFormGroup {
    const id = type.id;
    if (!this.publishFormMap[id]) {
      this.publishFormMap[id] = new UntypedFormGroup({
        isWorkflowValid: new UntypedFormControl(1, Validators.max(0)),
        reason: new UntypedFormControl('', Validators.required)
      });
      this.isValidatingMap[id] = false;
      this.customFieldMigrationQueueItemsMap[id] = [];
      this.hasContractorToRegistrationMoveMap[id] = false;
      this.hasRegistrationToContractorMoveMap[id] = false;
    }
    return this.publishFormMap[id];
  }

  async onOpenPublish(type: ContractorType): Promise<void> {
    const id = type.id;
    const form = this.getPublishForm(type);

    this.isValidatingMap[id] = true;
    form.controls['isWorkflowValid'].setValue(1);
    form.controls['reason'].setValue('');
    form.controls['reason'].markAsPristine();
    form.controls['reason'].markAsUntouched();

    this.customFieldMigrationQueueItemsMap[id] = [];
    this.hasContractorToRegistrationMoveMap[id] = false;
    this.hasRegistrationToContractorMoveMap[id] = false;

    try {
      const reg = await this._validationSvc.validate(type.registerWorkflowId);
      const ren = await this._validationSvc.validate(type.renewWorkflowId);
      const totalErrors = [...(reg || []), ...(ren || [])].length;

      form.controls['isWorkflowValid'].setValue(totalErrors);

      const queue = await this._contractorSvc.getPendingCustomFieldMigrations(
        type.id
      );
      this.customFieldMigrationQueueItemsMap[id] = queue || [];
      this.hasContractorToRegistrationMoveMap[id] = (queue || []).some(
        q =>
          q.operationType ===
          CustomFieldDataOperationType.MoveEntityFromContractorToRegistrationForm
      );
      this.hasRegistrationToContractorMoveMap[id] = (queue || []).some(
        q =>
          q.operationType ===
          CustomFieldDataOperationType.MoveEntityFromRegistrationToContractorForm
      );
    } catch (err) {
      this.gpError.handleError(err);
      form.controls['isWorkflowValid'].setValue(1);
    } finally {
      this.isValidatingMap[id] = false;
    }
  }

  openTypeActionModal(
    type: ContractorType,
    action: 'publish' | 'delete' | 'copy'
  ): void {
    this.updateOverlayOffset();
    this.toggleParentScroll(true); // added by Vipul on 09-07-2026
    this.selectedType = type;
    this.currentTypeAction = action;

    const actionNames = { publish: 'Publish', delete: 'Delete', copy: 'Copy' };
    this.typeActionModalTitle = `${actionNames[action]} ${type.name}`;

    this.isTypeActionModalOpen = true;

    if (action === 'publish') this.onOpenPublish(type);
    if (action === 'copy') this.onOpenCopy(type);
  }

  closeTypeActionModal(): void {
    this.toggleParentScroll(false); // added by Vipul on 09-07-2026
    this.isTypeActionModalOpen = false;
    this.currentTypeAction = null;
    this.selectedType = null;
  }

  confirmTypeAction(): void {
    if (!this.selectedType || !this.currentTypeAction) return;

    if (this.currentTypeAction === 'publish') {
      this.publish(this.selectedType);
      return;
    }

    if (this.currentTypeAction === 'delete') {
      this.deleteType(this.selectedType);
      return;
    }

    if (this.currentTypeAction === 'copy') {
      this.confirmCopy(this.selectedType, null);
      return;
    }
  }

  publish(type: ContractorType): void {
    const form = this.getPublishForm(type);
    if (form.invalid) {
      form.markAllAsTouched();
      return;
    }

    const reason = (form.controls['reason'].value || '').toString().trim();
    if (!reason) {
      form.controls['reason'].setValue('');
      form.controls['reason'].markAsTouched();
      return;
    }

    this.isLoading = true;
    this._contractorSvc
      .publishContractorType(type.id, reason)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (success: boolean) => {
          if (success) {
            this.toastr.success(
              'Contractor Type published successfully.',
              'Success!',
              { onActivateTick: true }
            );
            this.closeTypeActionModal();
            this.loadContractorTypes();
          } else {
            this.gpError.handleError(
              new Error('Publish failed (API returned false).')
            );
            this.hasError = true;
            this.errorMessage = 'Publish failed. Please try again.';
          }
        },
        error: err => {
          this.gpError.handleError(err);
          this.hasError = true;
          this.errorMessage = 'Publish failed. Please try again.';
        }
      });
  }

  deleteType(type: ContractorType): void {
    if (!type) return;
    this.isLoading = true;

    this._contractorSvc
      .deleteContractorType(type.id)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (success: boolean) => {
          if (success) {
            this.toastr.success(
              'Contractor Type deleted successfully.',
              'Success!',
              { onActivateTick: true }
            );
            this.closeTypeActionModal();
            this.loadContractorTypes();
          } else {
            this.gpError.handleError(
              new Error('Delete failed (API returned false).')
            );
            this.hasError = true;
            this.errorMessage = 'Delete failed. Please try again.';
          }
        },
        error: err => {
          this.gpError.handleError(err);
          this.hasError = true;
          this.errorMessage = 'Delete failed. Please try again.';
        }
      });
  }

  getCopyForm(type: ContractorType): UntypedFormGroup {
    const id = type.id;
    if (!this.copyFormMap[id]) {
      this.copyFormMap[id] = new UntypedFormGroup({
        targetClientId: new UntypedFormControl('', Validators.nullValidator),
        targetName: new UntypedFormControl('', Validators.required)
      });
    }
    return this.copyFormMap[id];
  }

  onOpenCopy(type: ContractorType): void {
    const form = this.getCopyForm(type);
    if (this._context.client) {
      form.controls['targetClientId'].setValue(this._context.client.id);
    }
    form.controls['targetName'].setValue(`Copy Of - ${type.name}`);
    form.controls['targetName'].markAsPristine();
    form.controls['targetName'].markAsUntouched();

    if (!this.adminClientsLoaded) {
      this._clientSvc.getAdminClients().subscribe({
        next: (c: any[]) => {
          this.clients = c || [];
          this.clientOptions = this.clients.map(client => ({
            label: client.name,
            value: client.id
          }));

          this.adminClientsLoaded = true;
          if ((this.clients || []).length === 1 && this.clients[0]?.id) {
            form.controls['targetClientId'].setValue(this.clients[0].id);
          }
        },
        error: err => {
          this.gpError.handleError(err);
          this.clients = [];
        }
      });
    }
  }

  confirmCopy(type: ContractorType, copyModal: any): void {
    const form = this.getCopyForm(type);
    if (form.invalid) {
      form.markAllAsTouched();
      return;
    }

    const targetClientId =
      form.controls['targetClientId'].value || this._context.client?.id;
    const targetName = (form.controls['targetName'].value || '')
      .toString()
      .trim();

    if (!targetName) {
      form.controls['targetName'].setValue('');
      form.controls['targetName'].markAsTouched();
      return;
    }

    const request: CopyContractorTypeRequest = {
      contractorTypeId: type.id,
      clientId: targetClientId,
      name: targetName
    };

    this.isLoading = true;
    this._contractorSvc
      .copyContractorType(request)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.toastr.success(
            'Contractor Type copied successfully.',
            'Success!',
            { onActivateTick: true }
          );
          if (copyModal && copyModal.cancel) copyModal.cancel();
          this.closeTypeActionModal();
          this.loadContractorTypes();
        },
        error: err => {
          this.gpError.handleError(err);
          if (copyModal && copyModal.cancel) copyModal.cancel();
          this.hasError = true;
          this.errorMessage = 'Copy failed. Please try again.';
        }
      });
  }

  openWorkflowHistory(workflowId: string, title: string): void {
    if (!workflowId) return;
    this.selectedWorkflowId = workflowId;
    this.checkpoints = null;

    this._workflowSvc.getWorkflowCheckpoints(workflowId).subscribe({
      next: (res: WorkflowCheckpoint[]) => {
        this.checkpoints = res || [];
        this.openHistoryModal(`Workflow History - ${title}`);
      },
      error: err => {
        this.gpError.handleError(err);
        this.checkpoints = [];
        this.openHistoryModal(`Workflow History - ${title}`);
      }
    });
  }

  openPublishHistory(workflowId: string, title: string): void {
    this.updateOverlayOffset();
    if (!workflowId) {
      return;
    }

    this.selectedPublishWorkflowId = workflowId;
    this.publishHistoryModalTitle = `${title} Publish History`;
    this.isPublishHistoryModalOpen = true;
  }

  closePublishHistoryModal(): void {
    this.isPublishHistoryModalOpen = false;
    this.selectedPublishWorkflowId = null;
    this.publishHistoryModalTitle = '';
  }

  private openHistoryModal(title: string): void {
    this.updateOverlayOffset();
    this.historyModalTitle = title;
    this.isHistoryModalOpen = true;
  }

  closeHistoryModal(): void {
    this.isHistoryModalOpen = false;
  }

  restoreCheckpoint(_id: string): void {
    this.closeHistoryModal();
    this.loadContractorTypes();
  }

  canEnable(row: ContractorRegistrationRow): boolean {
    const status = (row.status || '').toLowerCase();
    return CONTRACTOR_STATUS_CONFIG.enableAllowed.includes(status);
  }

  canDisable(row: ContractorRegistrationRow): boolean {
    const status = (row.status || '').toLowerCase();
    return CONTRACTOR_STATUS_CONFIG.disableAllowed.includes(status);
  }

  canDelete(row: ContractorRegistrationRow): boolean {
    const status = (row.status || '').toLowerCase();
    return !CONTRACTOR_STATUS_CONFIG.deleteBlocked.includes(status);
  }

  canRenew(row: ContractorRegistrationRow): boolean {
    const status = (row.status || '').toLowerCase();
    return !CONTRACTOR_STATUS_CONFIG.renewBlocked.includes(status);
  }

  canViewHistory(): boolean {
    return this.canManageContractors;
  }

  viewDetails(
    row: ContractorRegistrationRow,
    clientId: string,
    event?: Event
  ): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (clientId && row.id) {
      if (this.canManageContractors) {
        this.router.navigate([
          '/admin/jurisdiction',
          clientId,
          'contractors',
          'registration-details',
          row.id
        ]);
      } else {
        this.router.navigate(['/auth', 'registration-details', row.id]);
      }
    }
  }

  viewProfile(
    row: ContractorRegistrationRow,
    clientId: string,
    event?: Event
  ): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (clientId && row.contractorId) {
      this.router.navigate([
        '/admin/jurisdiction',
        clientId,
        'contractors',
        'contractor-profile',
        row.contractorId
      ]);
    }
  }

  openInline(
    type: 'details' | 'application' | 'renew' | 'profile',
    row: ContractorRegistrationRow,
    typeId: string,
    tableRef: any,
    event?: Event
  ): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!tableRef || !row) {
      return;
    }

    this.expandedComponent = null;
    this.expandedComponentInputs = null;

    if (typeof tableRef.closeExpansion === 'function') {
      tableRef.closeExpansion();
    } else {
      tableRef.expandedRow = null;
    }

    setTimeout(() => {
      switch (type) {
        case 'details':
          this.expandedComponent = StaffContractorRegistrationDetailsComponent;
          break;

        case 'application':
          if (!row.createdApplicationId) {
            this.toastr.warning(
              'Application is not available for this registration.'
            );
            return;
          }

          this.expandedComponent = ContractorsJanusApplicationComponent;
          break;

        case 'renew':
          this.expandedComponent = ContractorsJanusRenewComponent;
          break;

        case 'profile':
          if (!row.contractorId) {
            this.toastr.warning(
              'Contractor profile is not available for this registration.'
            );
            return;
          }

          this.expandedComponent = ContractorsJanusProfileViewComponent;
          break;

        default:
          return;
      }

      this.expandedComponentInputs = (tableRow: ContractorRegistrationRow) => {
        const commonInputs = {
          row: tableRow,
          registrationId: tableRow.id,
          closeExpansion: () => {
            this.expandedComponent = null;
            this.expandedComponentInputs = null;

            if (typeof tableRef.closeExpansion === 'function') {
              tableRef.closeExpansion();
            } else {
              tableRef.expandedRow = null;
            }
          }
        };

        switch (type) {
          case 'details':
            return {
              ...commonInputs
            };

          case 'application':
            return {
              ...commonInputs,
              applicationId: tableRow.createdApplicationId
            };

          case 'renew':
            return {
              ...commonInputs,
              contractorId: tableRow.contractorId,
              contractorTypeId: typeId
            };

          case 'profile':
            return {
              ...commonInputs,
              contractorId: tableRow.contractorId
            };

          default:
            return commonInputs;
        }
      };

      tableRef.expandRow(row);
    }, 0);
  }

  openActionModal(
    row: ContractorRegistrationRow,
    action: ContractorRegistrationAction,
    typeId: string,
    event?: Event
  ): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.updateOverlayOffset();

    this.selectedRow = row;
    this.currentAction = action;
    this.selectedTypeId = typeId;
    this.registrationModalIsSuccess = false;

    if (action === 'disable') {
      this.registrationModalTitle = 'Disable Registration';
      this.registrationModalDesc =
        'Are you sure you want to disable this registration?';
    } else if (action === 'enable') {
      this.registrationModalTitle = 'Enable Registration';
      this.registrationModalDesc =
        'This registration will be restored to a status determined by its expiration date and/or requirements.\n\nAre you sure you want to enable this registration?';
    } else if (action === 'delete') {
      this.registrationModalTitle = 'Delete Registration';
      this.registrationModalDesc =
        'Are you sure you want to delete this registration?';
    }

    this.isRegistrationActionModalOpen = true;
  }

  confirmAction(): void {
    if (!this.selectedRow?.id || !this.currentAction || !this.selectedTypeId)
      return;

    const row = this.selectedRow;
    const action = this.currentAction;

    this.isRegistrationActionModalOpen = false;
    this.isTableLoading = true;

    if (action === 'enable') {
      this._contractorSvc.reEnableContractorRegistration(row.id).subscribe({
        next: (res: boolean) => {
          if (res) {
            row.disabled = false;
            if ((row as any)._previousStatus) {
              row.status = (row as any)._previousStatus;
            }
            this.currentRegistrations = [...this.currentRegistrations];
            this.openSuccessModal(action);
          }
          this.isTableLoading = false;
        },
        error: err => {
          console.error(err);
          this.isTableLoading = false;
        }
      });
    }

    if (action === 'disable') {
      (row as any)._previousStatus = row.status;
      this._contractorSvc.disableContractorRegistration(row.id).subscribe({
        next: (res: boolean) => {
          if (res) {
            row.status = 'Disabled';
            (row as any).disabled = true;
            this.currentRegistrations = [...this.currentRegistrations];
            this.openSuccessModal(action);
          }
          this.isTableLoading = false;
        },
        error: err => {
          console.error(err);
          this.isTableLoading = false;
        }
      });
    }

    if (action === 'delete') {
      this._contractorSvc.deleteContractorRegistration(row.id).subscribe({
        next: () => {
          this.currentRegistrations = this.currentRegistrations.filter(
            r => r.id !== row.id
          );
          this.openSuccessModal(action);
          this.isTableLoading = false;
        },
        error: err => {
          console.error(err);
          this.isTableLoading = false;
        }
      });
    }

    this.currentAction = null;
  }

  getSuccessMessage(action: string): string {
    switch (action) {
      case 'disable':
        return 'The registration has been disabled successfully.';
      case 'enable':
        return 'The registration has been enabled successfully.';
      case 'delete':
        return 'The registration has been deleted successfully.';
      default:
        return 'Action completed successfully.';
    }
  }

  openSuccessModal(action: string): void {
    this.updateOverlayOffset();
    this.registrationModalTitle = 'Contractors';
    this.registrationModalDesc = this.getSuccessMessage(action);
    this.registrationModalIsSuccess = true;
    this.isRegistrationActionModalOpen = true;
  }

  closeModal(): void {
    this.isRegistrationActionModalOpen = false;
    this.currentAction = null;
    this.selectedRow = null;
    this.currentRegistrations = [...this.currentRegistrations];
  }

  cancelAction(): void {
    this.isRegistrationActionModalOpen = false;
    this.currentAction = null;
  }

  private updateOverlayOffset(): void {
    const sectionEl = document.querySelector(
      '.grey-container'
    ) as HTMLElement | null;

    if (!sectionEl) {
      this.overlayOffsetTop = 0;
      return;
    }

    const rect = sectionEl.getBoundingClientRect();
    const hiddenTop = Math.max(-rect.top, 0);
    this.overlayOffsetTop = hiddenTop + 24;
  }

  // Navigate to workflow builder with state added by Deepak 06/05/2026
  openBuilder1(workflowId: string): void {
    this.router.navigate(['/admin/workflow-builder', workflowId], {
      state: {
        returnUrl: this.router.url
      }
    });
  }
  // End of code added by Deepak 06/05/2026
  // Navigate to workflow builder with state added by Deepak 06/05/2026
  openBuilder2(workflowId: string): void {
    this.router.navigate(['/admin/workflow-builder', workflowId], {
      state: {
        returnUrl: this.router.url
      }
    });
  }
  // End of code added by Deepak 06/05/2026

  // Code added by Vipul on 09-07-2026
  private toggleParentScroll(disable: boolean): void {
    const bodyContainer = document.querySelector(
      '.contractors-body-container'
    ) as HTMLElement;

    if (bodyContainer) {
      disable
        ? bodyContainer.style.setProperty('overflow-y', 'hidden', 'important')
        : bodyContainer.style.setProperty('overflow-y', 'auto', 'important');
      disable
        ? bodyContainer.style.setProperty('overflow-x', 'hidden', 'important')
        : bodyContainer.style.setProperty('overflow-x', 'auto', 'important');
    }
  }
  // Code added by Vipul on 09-07-2026

  openImportDialog(): void {
    this._dialog
      .open(ImportContractorTypeModalComponent, {
        width: '700px',
        disableClose: true,
        data: { targetClientId: this._context.client?.id }
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.loadContractorTypes();
        }
      });
  }

  exportContractorType(type: ContractorType): void {
    this._contractorSvc
      .exportContractorType(type.id)
      .subscribe((blob: Blob) => {
        const safeName = (type.name || 'contractor-type')
          .replace(/[^\w\-]/g, '-')
          .toLowerCase();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `contractor-type-${safeName}-export.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
  }
}
